<template>
    <div class="text-sm overflow-x-scroll">
        <ul class="list-reset flex">
            <li v-for="s in series" class="">
                <a
                        @click="seriesToggle(s.series)"
                        class="p-4 w-64 border flex shadow mr-4"
                        :class="{'bg-blue-lightest': isSelected(s.series)}"
                >
                    <div>{{ s.series.description.en }}
                        {{ s.series.begin.substr(0,4) }} - {{ s.series.end.substr(0,4) }}
                    </div>

                    <div class="mt-4 text-grey">
                        Unit: {{ s.series.unit }},
                        Range: {{ s.series.begin.substring(0,4) }} - {{ s.series.end.substring(0,4) }}
                    </div>

                    <div class="w-full pl-4">
                        <p class="text-xs text-grey uppercase tracking-wide">Latest Value</p>
                        <p class="text-grey-dark pt-2 text-right">
                            {{ s.series.latest | number_format }}
                        </p>
                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {

        inject: ['report'],

        props: ['q'],

        data: function () {
            return {
                series: [],
            };
        },

        created: function () {
            window.http.get('/api/v1/series/search?query=' + this.q).then((response) => {
                this.series = response.data.series;
            });
        },

        filters: {
            number_format: function(number) {
                return new Intl.NumberFormat('en-GB').format(number);
            },
        },

        methods: {
            isSelected(series) {
                return this.report.selected.findIndex(function (item) {
                    return item.id === series.id;
                }) !== -1;
            },

            seriesToggle: function (series) {
                // check if already in list
                if (!this.isSelected(series)) {
                    this.report.selected.push(series);
                    return;
                }

                this.report.selected = this.report.selected.filter(function (item) {
                    return item.id !== series.id;
                });
            },
        },



    };
</script>